










import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

import dataStore from "@/store";
import PlushieStore from "@/modules/plushie/store";
import Plushie from "@/modules/plushie/plushie.model";
import { Dictionary } from "@/lib/Dictionary.type";
import UpgradeLabelResolverService from "@/modules/plushie/upgrade-label-resolver.service";

interface Item {
  name: string;
  qty: number;
}

@Component({
  components: {},
})
export default class CreateBulkShipmentFormSummary extends Vue {
  @Prop({ required: true })
  public readonly plushieIds!: string[];

  @Inject("UpgradeLabelResolverService")
  private fUpgradeLabelResolver!: UpgradeLabelResolverService;

  private fPlushieDataStore: PlushieStore;

  get plushies(): Plushie[] {
    return this.fPlushieDataStore.getPlushiesByIds(this.plushieIds);
  }

  get totalSkuQty(): number {
    let qty = 0;
    this.plushies.forEach((plushie) => {
      qty += plushie.quantity;
    });

    return qty;
  }

  get upgradesSummary(): Dictionary<Item> {
    const items: Dictionary<Item> = {};

    this.plushies.forEach((plushie) => {
      const relations = this.fPlushieDataStore.getPlushieUpgradeRelationsByPlushieId(
        plushie.id
      );

      relations.forEach((relation) => {
        const upgrade = this.fPlushieDataStore.getUpgradeById(relation.upgrade);

        if (!upgrade) {
          return;
        }

        const quantity = relation.quantity || 1;

        if (items[upgrade.id]) {
          items[upgrade.id].qty += quantity;
          return;
        }

        items[upgrade.id] = {
          qty: quantity,
          name:
            upgrade.shortName || this.fUpgradeLabelResolver.resolve(upgrade),
        };
      });
    });

    return items;
  }

  constructor() {
    super();
    this.fPlushieDataStore = getModule(PlushieStore, dataStore);
  }
}
